// extracted by mini-css-extract-plugin
module.exports = {"image":"LAndRLicence_image__GahCJ"};